'use client';

import { Fragment, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Transition, TransitionChild } from '@headlessui/react';
import { IconArrowRight1 } from '@/features/icons';
import { useDisableBodyScroll } from '@/features/modal/utils/use-disable-body-scroll';
import SearchInputField from './search-input-field';
import SearchResults from './search-results';
import { useSearchModal } from './context/search-modal-context';
import { generateSearchUrl } from './utils/search-helpers';
import { useSearchQuery } from './utils/use-search-query';
import { useSearchResults } from './utils/use-search-results';
import { useSearchSubmit } from './utils/use-search-submit';
import { useCategoryModal } from '../category-modal/context/category-modal-context';
function SearchModal() {
  const router = useRouter();
  const {
    isOpen: isSearchModalOpen,
    inputRef
  } = useSearchModal();
  const {
    isOpen: isCategoryModalOpen
  } = useCategoryModal();
  const {
    query,
    setQuery,
    setInitialQuery
  } = useSearchQuery();
  const {
    results,
    noResult,
    isFetching,
    isError
  } = useSearchResults(query, isSearchModalOpen);
  const {
    disableScroll,
    enableScroll
  } = useDisableBodyScroll(true);
  const handleSubmit = useSearchSubmit({
    query,
    setQuery,
    onSubmit: () => inputRef.current?.blur()
  });
  const handleBackClick = () => {
    router.back();
  };
  const beforeLeaveHandler = () => {
    if (isCategoryModalOpen) return;
    enableScroll();
  };
  useEffect(() => {
    if (!isSearchModalOpen) return;
    setInitialQuery();
  }, [isSearchModalOpen, setInitialQuery]);
  return <Transition show={isSearchModalOpen} as={Fragment} afterEnter={disableScroll} beforeLeave={beforeLeaveHandler} data-sentry-element="Transition" data-sentry-component="SearchModal" data-sentry-source-file="search-modal.tsx">
            <TransitionChild as={Fragment} enter='transition ease-out duration-300 transform' enterFrom='translate-y-full' enterTo='translate-y-0' leave='transition ease-in duration-200 transform' leaveFrom='translate-y-0' leaveTo='translate-y-full' data-sentry-element="TransitionChild" data-sentry-source-file="search-modal.tsx">
                <div className='fixed inset-0 z-top-of-navigation-bar flex flex-col bg-white lg:hidden'>
                    <form className='mb-5 flex h-14 w-full shrink-0 items-center gap-1 p-2 shadow-sm' autoComplete='off' data-test='search-form-mobile' onSubmit={handleSubmit} action={generateSearchUrl()}>
                        <button type='button' onClick={handleBackClick} className='shrink-0 cursor-pointer' aria-label='بستن'>
                            <IconArrowRight1 className='h-6 w-6 text-text-black' data-sentry-element="IconArrowRight1" data-sentry-source-file="search-modal.tsx" />
                        </button>

                        <SearchInputField ref={inputRef} query={query} setQuery={setQuery} isFetching={isFetching} className='flex-1' inputClassName='border-border-gray-medium bg-transparent' data-sentry-element="SearchInputField" data-sentry-source-file="search-modal.tsx" />
                    </form>

                    <div className='hide-scrollbar flex-1 overflow-auto bg-white px-2 pb-6'>
                        <SearchResults isFetching={isFetching} query={query} noResult={noResult} isError={isError} results={results} isOpen={isSearchModalOpen} variant='mobile' data-sentry-element="SearchResults" data-sentry-source-file="search-modal.tsx" />
                    </div>
                </div>
            </TransitionChild>
        </Transition>;
}
export default SearchModal;